import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./index.css";
import MainLayout from "./components/MainLayout";
import Home from "./components/Home";
import About from "./components/About";
import Collection from "./components/Collection";

const App = () => {
    return (
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/collection" element={<Collection />} />

        </Route>
        
      </Routes>
    </Router>
    );
};

export default App;
